import { CardContainer, DefaultSkeletonLoader, Skeleton } from '@diana/core';
import { alpha, Card, useTheme } from '@mui/material';

export const WorkflowSkeletonCard = () => {
  const { palette } = useTheme();
  const bgColor = alpha(palette.background.paper, 0.5);

  const skeletonLayout = [
    {
      animation: 'wave',
      variant: 'rounded',
      width: 36,
      height: 36,
      sx: { mb: 4 },
    },
    {
      animation: 'wave',
      variant: 'text',
      width: 62,
      height: 12,
      sx: { mb: 0.5, transform: 'none' },
    },
    {
      animation: 'wave',
      variant: 'text',
      width: 124,
      height: 12,
      sx: { transform: 'none' },
    },
  ];

  return (
    <CardContainer>
      <Card
        data-testid="WorkflowSkeletonCard"
        sx={{
          width: '100%',
          height: '100%',
          backgroundColor: bgColor,
          cursor: 'auto',
          p: 2,
          opacity: 0.5,
          '&:hover': { backgroundColor: bgColor },
        }}
      >
        <Skeleton
          count={1}
          renderItem={<DefaultSkeletonLoader layout={skeletonLayout} />}
          boxPadding={0}
        />
      </Card>
    </CardContainer>
  );
};
